"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pushbutton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const pushbutton_style_1 = __importDefault(require("./pushbutton.style"));
const Pushbutton = ({ classes, children, onClick = null, buttonRef: ref = null, primary = false, secondary = false, warning = false, hasPopup = false, disabled = false, type = 'button', prefix = null, suffix = null, dataCy = 'atomic-pushbutton', sexyShadow = false, complete = false, formId = null }) => {
    const handleClick = () => {
        if (!disabled && onClick)
            onClick();
    };
    const rootProps = {
        onClick: handleClick,
        type,
        className: classes.root,
        disabled,
        ref,
        form: formId || null,
        'data-is-primary': primary,
        'data-is-secondary': secondary,
        'data-is-warning': warning,
        'aria-haspopup': hasPopup,
        'data-cy': dataCy || 'atomic-pushbutton',
        'data-is-sexy-shadow': sexyShadow,
        'data-is-complete': complete
    };
    return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0),
            jsx_runtime_1.jsx("span", Object.assign({ className: classes.text }, { children: children }), void 0),
            suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0));
};
exports.Pushbutton = Pushbutton;
exports.default = react_jss_1.default(pushbutton_style_1.default)(exports.Pushbutton);
//# sourceMappingURL=index.js.map